import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import MarketTicker from './components/MarketTicker';
import Footer from './components/Footer';
import ChatBot from './components/ChatBot';
import { Toaster } from './components/ui/toaster';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import BusinessAreasPage from './pages/BusinessAreasPage';
import ServicesPage from './pages/ServicesPage';
import ServiceDetailsPage from './pages/ServiceDetailsPage';
import FAQPage from './pages/FAQPage';
import ExclusiveExecutivePage from './pages/ExclusiveExecutivePage';
import NewsPage from './pages/NewsPage';
import ArticlePage from './pages/ArticlePage';
import ContactPage from './pages/ContactPage';
import PolicyPage from './pages/PolicyPage';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navigation />
        <div className="pt-20">
          <MarketTicker />
        </div>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/business-areas" element={<BusinessAreasPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/service-details" element={<ServiceDetailsPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/exclusive-executive" element={<ExclusiveExecutivePage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/article/:articleId" element={<ArticlePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/policy" element={<PolicyPage />} />
        </Routes>
        <Footer />
        <ChatBot />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
